import React, { Component } from 'react';
import House from '../../static/img/house.svg'
import Barchart from '../barchart';
import style from '../../style/style';
import Loading from '../loading';

class Tenancy extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (!this.props.data) return (<Loading fill={style.colors.primary} height="32px" width="32px" container={true} />);
    
    const data = { ...this.props };

    return (
      <div
        style={{ ...style.fact.layout }}
      > 
        <div style={{ ...style.fact.left }}>
          <img src={House} style={{ width: style.fact.left.width, padding: style.padding, fill: style.colors.primary }}  />
        </div>
        <div style={{ ...style.fact.right }}>
          <h2 style={{ ...style.fact.heading }}>
            { `${data.data.T6_3_TH} households` }
          </h2>
          <Barchart
            data={ data.data }
            verb="are"
            fields={[
              { "name": "mortgages or loans", "value": "T6_3_OMLH" },
              { "name": "owned outright", "value": "T6_3_OOH" },
              { "name": "rented privately", "value": "T6_3_RPLH" },
              { "name": "occupied rent free", "value": "T6_3_OFRH" },
              { "name": "housing bodies, co-ops", "value": "T6_3_RVCHBH" },
              { "name": "local authority", "value": "T6_3_RLAH" },
              { "name": "not stated", "value": "T6_3_NSH" }
            ]}
            total={ "T6_3_TH" }
          />
          <div style={{ ...style.fact.source }}>Source: Census 2016, <a href="http://www.cso.ie/">cso.ie</a>.</div>
        </div>
      </div>);
  }
}

export default Tenancy;



// WEBPACK FOOTER //
// ./src/components/tenancy/index.js